<template>
  <div class="wrap">
    <div class="home-card">
      <img src="@/assets/images/home-card.svg">
      <img src="@/assets/images/home-card-back.svg">
    </div>
    <p>CARD GAME</p>
    <button @click="$emit('update:view', 'Game')">開始</button>
    <p>最高分數：<span class="score">{{ score }}</span></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      score: 0,
    };
  },
  mounted() {
    if (localStorage.getItem('score')) {
      this.score = localStorage.getItem('score');
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  p {
    font-size: 28px;
    font-weight: bold;
    color: #535353;
  }
  span {
    color: #eba926;
  }
  button {
    &:hover {
      background: lighten(#535353, 10%);
    }
    &:focus {
      outline: 0;
    }
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
    border-radius: 999px;
    border: 0;
    background: #535353;
    width: 100px;
    height: 52px;
    color: #FBC150;
    font-size: 24px;
    font-weight: bold;
    transition: all .3s ease-out;
    cursor: pointer;
    margin-bottom: 32px;
  }
  .home-card {
    img {
      &:nth-of-type(1) {
        z-index: 2;
      }
      &:nth-of-type(2) {
        z-index: 1;
        transform: translate(-50%, -50%) rotateZ(37deg) rotateY(180deg);
      }
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotateZ(37deg);
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
    }
    position: relative;
    width: 200px;
    height: 200px;
    animation: card 2.5s linear infinite;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    @keyframes card {
      to {
        transform: rotate3d(0, 1, 0, 0deg);
      }
      from {
        transform: rotate3d(0, 1, 0, 360deg);
      }
    }
  }
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
